export default {
  lineNumberColor: `#a39e9b`,
  lineNumberBgColor: `#2f1e2e`,
  backgroundColor: `#2f1e2e`,
  textColor: `#a39e9b`,
  substringColor: `#a39e9b`,
  keywordColor: `#815ba4`,
  attributeColor: `#fec418`,
  selectorAttributeColor: `#815ba4`,
  docTagColor: `#a39e9b`,
  nameColor: `#ef6155`,
  builtInColor: `#f99b15`,
  literalColor: `#f99b15`,
  bulletColor: `#48b685`,
  codeColor: `#a39e9b`,
  additionColor: `#48b685`,
  regexpColor: `#ef6155`,
  symbolColor: `#48b685`,
  variableColor: `#ef6155`,
  templateVariableColor: `#ef6155`,
  linkColor: `#ef6155`,
  selectorClassColor: `#ef6155`,
  typeColor: `#f99b15`,
  stringColor: `#48b685`,
  selectorIdColor: `#ef6155`,
  quoteColor: `#8d8687`,
  templateTagColor: `#a39e9b`,
  deletionColor: `#f99b15`,
  titleColor: `#fec418`,
  sectionColor: `#fec418`,
  commentColor: `#8d8687`,
  metaKeywordColor: `#a39e9b`,
  metaColor: `#ef6155`,
  functionColor: `#a39e9b`,
  numberColor: `#f99b15`,
}
